

















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class LayoutSection extends Vue {

    @Prop(String) title!: string
    @Prop(String) subtitle!: string
}

